import { render, staticRenderFns } from "./ThemedTable.vue?vue&type=template&id=0d848b1c"
import script from "./ThemedTable.vue?vue&type=script&lang=js"
export * from "./ThemedTable.vue?vue&type=script&lang=js"
import style0 from "./ThemedTable.vue?vue&type=style&index=0&id=0d848b1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports